import axios from "axios";
import { API_BASE_URL } from "../../config";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export async function verifyCoinToss({ game, roundId, serverSeed }) {
  const path =
    game === "flip"
      ? "/api/coin-flip/rounds/verify"
      : game === "dice"
      ? "/api/bond-dice/rounds/verify"
      : "/api/coin-pool/rounds/verify";
  const res = await api.post(path, { roundId, serverSeed });
  return res.data;
}

export function truncateHash(value, head = 8, tail = 6) {
  if (!value || value.length <= head + tail + 3) return value || "";
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}
